import memo from "set-state-compare/src/memo"
import React from "react"

const ComponentsLayoutLoadingSpinner = () =>
  <div className="fa-3x" style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%"}}>
    <i className="fas fa-spinner fa-spin" />
  </div>

export default memo(ComponentsLayoutLoadingSpinner)
